// extracted by mini-css-extract-plugin
export var active = "Tag-module--active--20d48";
export var dark = "Tag-module--dark--64e3f";
export var disabled = "Tag-module--disabled--0234e";
export var fadeInAnimation = "Tag-module--fadeInAnimation--f2445";
export var lg = "Tag-module--lg--5a158";
export var light = "Tag-module--light--c9ed6";
export var md = "Tag-module--md--1ecfa";
export var rounded = "Tag-module--rounded--ba979";
export var sm = "Tag-module--sm--598ec";
export var tag = "Tag-module--tag--4cb03";
export var withCross = "Tag-module--withCross--f32a2";